/**
 * New Transport UI — a vehicle registration drawn like a real UK number plate: a yellow, rounded oblong with black
 * lettering. `short` shows only the last three characters (used when there is not enough room for the full
 * registration) in the very same plate design. `size` is one of "sm" | "md" | "lg".
 */
const PLATE_YELLOW = '#fbd51a';
const PLATE_BLACK = '#15140f';

const SIZE_CLASS = {
  sm: 'text-[12px] px-2 py-[1px] rounded-md',
  md: 'text-[15px] px-2.5 py-[2px] rounded-lg',
  lg: 'text-[19px] px-3 py-[3px] rounded-lg',
};

export const plateText = (registration, short = false) => {
  const full = String(registration || '').trim().toUpperCase();
  if (!full) return 'NEW';
  return short ? full.replace(/\s+/g, '').slice(-3) : full;
};

const RegPlate = ({ registration, short = false, size = 'md', className = '', title, ...rest }) => (
  <span
    {...rest}
    title={title || registration || undefined}
    className={`inline-flex items-center justify-center flex-shrink-0 whitespace-nowrap font-extrabold leading-tight ${SIZE_CLASS[size] || SIZE_CLASS.md} ${className}`}
    style={{
      backgroundColor: PLATE_YELLOW,
      color: PLATE_BLACK,
      border: `2px solid ${PLATE_BLACK}`,
      letterSpacing: '0.08em',
      fontFamily: '"Arial Narrow", "Helvetica Neue", Arial, sans-serif',
      boxShadow: 'inset 0 1px 0 rgba(255,255,255,0.55), 0 1px 3px rgba(0,0,0,0.25)',
    }}
  >
    {plateText(registration, short)}
  </span>
);

export default RegPlate;
